<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-also-by element-with-heading" id="also-by">
<div class="heading heading-with-title heading-without-image" id="also-by-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Also by Anita Waller</h1>
</div>
</div>
</div>
</div>
<div class="text" id="also-by-text">
<p class="first first-in-chapter first-full-width also-by-content"><b><span class="underline"><span class="smallcaps">Kat and Mouse series</span></span></b></p>
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center also-by-content"><span class="content-external-link">Murder Undeniable (Book 1)</span></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><span class="content-external-link">Murder Unexpected (Book 2)</span></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><span class="content-external-link">Murder Unearthed (Book 3)</span></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><span class="content-external-link">Murder Untimely (Book 4)</span></p>
</div>
</div>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-square">
<div class="ornamental-break-size-container ornamental-break-width-125">
<img alt="" class="ornamental-break-image" src="images/break-snowflake-screen.png"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width also-by-content"><b><span class="underline"><span class="smallcaps">Psychological thrillers</span></span></b></p>
<p class="subsq also-by-content"><span class="content-external-link">Beautiful</span></p>
<p class="subsq also-by-content"><span class="content-external-link">Angel</span></p>
<p class="subsq also-by-content"><span class="content-external-link">34 Days</span></p>
<p class="subsq also-by-content"><span class="content-external-link">Strategy</span></p>
<p class="subsq also-by-content"><span class="content-external-link">Captor</span></p>
<p class="subsq also-by-content"><span class="content-external-link">Game Players</span></p>
<p class="subsq also-by-content"><span class="content-external-link">Malignant</span></p>
<p class="subsq also-by-content"><span class="content-external-link">Liars</span> (co-written with Patricia Dixon)</p>
<p class="subsq also-by-content"><span class="content-external-link">Gamble</span></p>
<p class="subsq also-by-content"><span class="content-external-link">Epitaph</span></p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-square">
<div class="ornamental-break-size-container ornamental-break-width-125">
<img alt="" class="ornamental-break-image" src="images/break-snowflake-screen.png"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width also-by-content"><b><span class="underline"><span class="smallcaps">Supernatural</span></span></b></p>
<p class="subsq also-by-content"><span class="content-external-link">Winterscroft</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// also-by-anita-waller.vue?7fb5f30a